import styled from "styled-components";
import photo from "assets/images/Suyane_Mike_HickDuarte_33731.jpg";
import photoMobile from "assets/images/Suyane_Mike_HickDuarte_33731_mobile.jpg";
import { motion } from "framer-motion";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  position: relative;
`;

export const Background = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: url(${photo}) no-repeat center center;
  background-size: cover;
  z-index: 1;

  @media screen and (max-width: 768px) {
    background: url(${photoMobile}) no-repeat center center;
    background-size: cover;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 100vh;
  padding: 124px;
`;

export const Credit = styled.article`
  width: 100%;
  max-width: 189px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  right: 72px;
  bottom: 124px;
  z-index: 3;

  @media screen and (max-width: 414px) {
    font-size: 10px;
    line-height: 16px;
    right: 32px;
    bottom: 72px;
  }
`;
